import { cn } from "@/lib/utils";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import { CodeBlock } from "@/components/storyboard/code/CodeBlock";
import type { QuizReviewBlock } from "@/lib/quizReview";

interface QuizReviewRevealProps {
  blocks: QuizReviewBlock[];
}

const labelToneStyles: Record<
  NonNullable<QuizReviewBlock["tone"]>,
  { frame: string; label: string }
> = {
  neutral: { frame: "border-gray-200", label: "text-gray-500" },
  success: { frame: "border-success-border", label: "text-success" },
  error: { frame: "border-error-border", label: "text-error" },
  secondary: { frame: "border-secondary/40", label: "text-secondary" },
};

const ReviewBlock = ({ block }: { block: QuizReviewBlock }) => {
  const tone = labelToneStyles[block.tone ?? "neutral"];
  return (
    <div className="flex flex-col gap-2">
      {block.label && (
        <span
          className={cn("font-semibold uppercase tracking-wide", tone.label)}
        >
          {block.label}
        </span>
      )}
      {block.kind === "code" ? (
        <CodeBlock code={block.content} />
      ) : (
        <div
          className={cn(
            "rounded-lg border p-4",
            tone.frame,
            block.tone === "success" && "bg-success-light"
          )}
        >
          <div className="prose max-w-full text-gray-700">
            <CourseMarkdown>{block.content}</CourseMarkdown>
          </div>
        </div>
      )}
    </div>
  );
};

const QuizReviewReveal = ({ blocks }: QuizReviewRevealProps) => (
  <div className="flex flex-col gap-3">
    {blocks.map((block, index) => (
      <ReviewBlock key={index} block={block} />
    ))}
  </div>
);

export default QuizReviewReveal;
